import axios from "axios";
import {
  getToken as _getTokenFromRefresh,
  handleAuthError,
  resetAuthRetryCount,
  createAuthRetryState,
} from "./_tokenRefresh";
import { getResourceTokenIfAvailable } from "./resourceToken";
import { resolveSkedApiBase } from "./_skedApiBase";

// for when you're testing the API locally
let useLocal = false;
export const baseUrl = resolveSkedApiBase({ useLocal });

const defaultOptions = {
  baseURL: baseUrl,
  headers: {
    "Content-Type": "application/json",
  },
};

/** option to force getting token from server, there is a problem when
 * skedApiToken did not clean up after logout (or token expired), and pusher used the old token
 */
let skedApiAuthMode = "unknown";

export function resetSkedApiAuthMode() {
  skedApiAuthMode = "unknown";
}

export async function getToken(forceRequest = false) {
  if (skedApiAuthMode !== "legacy") {
    const resourceToken = await getResourceTokenIfAvailable(
      "api",
      forceRequest
    );
    if (resourceToken) {
      skedApiAuthMode = "better-auth";
      return resourceToken;
    }
    skedApiAuthMode = "legacy";
  }

  return _getTokenFromRefresh(forceRequest);
}

export const skedApi = axios.create(defaultOptions);

skedApi.interceptors.request.use(async (config) => {
  const token = await getToken();
  config.headers.Authorization = `Bearer ${token}`;
  return config;
}, null);

const skedApiRetryState = createAuthRetryState();

skedApi.interceptors.response.use(
  (response) => {
    resetAuthRetryCount(skedApiRetryState);
    return response;
  },
  async (error) => {
    console.group("Error in skedApi");
    console.error(error);
    console.dir(error);
    console.groupEnd();

    if (error?.response?.status === 401) {
      if (skedApiAuthMode !== "legacy") {
        if (error.config && !error.config.__skedApiResourceTokenRetried) {
          error.config.__skedApiResourceTokenRetried = true;
          error.config.headers.Authorization = `Bearer ${await getToken(true)}`;
          return skedApi(error.config);
        }
        throw error;
      }
      return handleAuthError(skedApi, error, "skedApi", skedApiRetryState);
    } else {
      throw error;
    }
  }
);
